//Created by wangshuyi on 2021/1/14.

'use strict';
const DirectiveList = [
  {
    name: 'auth',
    options: {
      inserted(el, binding, vNode, oldVNode){
        let vue = window.$DolAntPage || window.$DolVantPage;
        if(vue
          && vue.$store
          && vue.$store.state.auth
          && vue.$store.state.auth instanceof Array
          && vue.$store.state.auth.find(item => item.CONTROL_NAME === binding.value)
        ){

        }else{
          el.remove();
        }
      }
    }
  }
]

export default DirectiveList;
